/**
 * Created by Qingger Corp.
 * User: Thinkpad
 * Date: 2019/6/10
 * Time: 9:37
 * Desc: 网点管理-网点信息-预约试穿及出样
 */

import { Component, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';

@Component
export default class BookingTryOnAndExample extends Vue {
  /* 数据 */

  /**
   * 试穿列表
   * @type {ItemObject}
   * 这里得有默认数据，否则渲染会报错
   */
  public tryOnList: ItemObject = {
    CustomerDdMsgReceiverIds: { desc: {} }, // 预约试穿信息接受导购
    CustomerTryOnIsOpen: { desc: {} }, // 预约试穿开关
    GuiderDdMsgReceiverIds: { desc: {} }, // 出样申请信息接收导购
    GuiderTryOnIsOpen: { desc: {} }, // 出样申请开关
  };

  /**
   * 试穿是否打开
   * @type {boolean}
   */
  public isTryOnOpen = false;

  /**
   * 出样是否打开
   * @type {boolean}
   */
  public isExampleOpen = false;

  /* 方法 */

  /**
   * 获取网点信息
   * @return null
   */
  public getSiteInfo(): void {
    const queryParams = {
      siteId: Number.parseInt(this.$route.params.siteId),
      moduleType: 3,
    };
    IPSService.siteInfo({ queryParams })
      .then((res) => {
        if (res && res.list) {
          const tryOnList = {};
          res.list.forEach((item) => {
            tryOnList[item.filedType] = item;
          });
          this.tryOnList = tryOnList;
          this.isTryOnOpen = this.tryOnList.CustomerTryOnIsOpen.desc === 1;
          this.isExampleOpen = this.tryOnList.GuiderTryOnIsOpen.desc === 1;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  /**
   * 格式化字符串
   * @param {string} str
   * @return {string}
   */
  public trim(str: string): string {
    str = str.replace(/，/gi, ','); // 去除中文逗号
    str = str.replace(/[\n\r]/g, ''); // 去除换行
    const strList = []; // 去除两端空格
    str.split(',').forEach((item) => {
      if (item) { strList.push(item.replace(/(^\s*)|(\s*$)/g, '')); }
    });
    return strList.join();
  }

  /**
   * 提交黑名单
   * @return null
   */
  public ontryOnListData(): void {
    // 格式化数据,去掉空格和中文逗号
    this.tryOnList.CustomerDdMsgReceiverIds.desc.receiverIds = this.trim(this.tryOnList.CustomerDdMsgReceiverIds.desc.receiverIds);
    this.tryOnList.GuiderDdMsgReceiverIds.desc.receiverIds = this.trim(this.tryOnList.GuiderDdMsgReceiverIds.desc.receiverIds);
    this.tryOnList.CustomerTryOnIsOpen.desc = this.isTryOnOpen ? 1 : 0;
    this.tryOnList.GuiderTryOnIsOpen.desc = this.isExampleOpen ? 1 : 0;
    if (this.isTryOnOpen && this.tryOnList.CustomerDdMsgReceiverIds.desc.receiverIds === '') {
      this.$message.error('预约试穿信息接受导购钉钉ID');
      return;
    } else if (this.isExampleOpen && this.tryOnList.CustomerDdMsgReceiverIds.desc.receiverIds === '') {
      this.$message.error('预约试穿信息接受导购钉钉ID');
      return;
    } else {
      // 组装参数
      const paramList = [];
      for (const item in this.tryOnList) {
        paramList.push(this.tryOnList[item]);
      }
      const postParams = {
        siteId: this.$route.params.siteId,
        list: paramList,
        moduleType: 3,
      };
      IPSService.saveSiteEdit({ postParams }).then((res) => {
        if (res) { this.$message.success('保存成功'); }
      });
    }
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getSiteInfo(); // 获取网点信息
  }
}
